import { cloneDeep, defaultsDeep, merge } from './util';

const defaults = {
  page: {}
};

export default class AnalyticsData {
  constructor(data = {}) {
    this.data = cloneDeep(defaultsDeep(data, defaults));
  }

  update(...args) {
    merge(this.data, ...args);
    return this.toJSON();
  }

  overlay(...args) {
    const eventData = {
      eventAction: null,
      eventLabel: null,
      eventCategory: null
    };
    return merge(eventData, this.data, ...args);
  }

  toJSON() {
    return cloneDeep(this.data);
  }
}
